module.exports = __webpack_public_path__ + "assets/share_students.e65ecf32.svg";